// Mock rentals (active and historical rental records)
export const mockRentals = [
  {
    id: "RENTAL-001",
    status: "active",
    customer: {
      id: "CUST789",
      name: "Emily Johnson",
      email: "emily.j@email.com",
      phone: "+1 (555) 987-6543",
      address: "456 Oak Lane, Anytown, ST 12345"
    },
    items: [
      {
        productId: "MALM001",
        name: "MALM Bed Frame",
        sku: "MALM-89129307",
        condition: {
          checkout: "Excellent",
          current: "Good"
        },
        pricing: {
          dailyRate: 15.99,
          deposit: 150.00
        }
      },
      {
        productId: "KALLAX001",
        name: "KALLAX Shelf Unit",
        sku: "KALLAX-80275887",
        condition: {
          checkout: "Excellent",
          current: "Excellent"
        },
        pricing: {
          dailyRate: 12.99,
          deposit: 100.00
        }
      }
    ],
    rentalPeriod: {
      startDate: "2024-03-15",
      endDate: "2024-04-15",
      duration: "1 month",
      pickupTime: "10:00 AM",
      returnTime: "5:00 PM"
    },
    location: {
      pickup: "Main Store - Furniture Pickup Area",
      return: "Main Store - Furniture Pickup Area"
    },
    delivery: {
      type: "Self Pickup",
      instructions: "Please bring valid ID and proof of address"
    },
    pricing: {
      itemsTotal: 428.98,
      delivery: 0,
      deposit: 250.00,
      insurance: 29.99,
      total: 458.97
    },
    insurance: {
      type: "Standard Coverage",
      provider: "IKEA Rental Protection",
      coverageDetails: [
        "Accidental damage",
        "Theft protection",
        "24/7 support"
      ],
      cost: 29.99,
      policyNumber: "INS-123456"
    },
    maintenanceHistory: [
      {
        date: "2024-03-25",
        type: "Inspection",
        itemId: "MALM001",
        technician: "Mike Wilson",
        notes: "Regular inspection, all components in good condition"
      }
    ]
  },
  {
    id: "RENTAL-002",
    status: "pending",
    customer: {
      id: "CUST456",
      name: "David Smith",
      email: "david.s@email.com",
      phone: "+1 (555) 123-4567",
      address: "789 Pine Street, Anytown, ST 12345"
    },
    items: [
      {
        productId: "POANG001",
        name: "POÄNG Armchair",
        sku: "POANG-89129308",
        condition: {
          checkout: "Excellent",
          current: "Excellent"
        },
        pricing: {
          dailyRate: 8.99,
          deposit: 100.00
        }
      }
    ],
    rentalPeriod: {
      startDate: "2024-04-01",
      endDate: "2024-05-01",
      duration: "1 month",
      pickupTime: "2:00 PM",
      returnTime: "3:00 PM"
    },
    location: {
      pickup: "Main Store - Furniture Pickup Area",
      return: "Main Store - Furniture Pickup Area"
    },
    delivery: {
      type: "Home Delivery",
      instructions: "Call 30 minutes before delivery",
      address: "789 Pine Street, Anytown, ST 12345"
    },
    pricing: {
      itemsTotal: 269.70,
      delivery: 49.99,
      deposit: 100.00,
      insurance: 19.99,
      total: 339.68
    },
    insurance: {
      type: "Basic Coverage",
      provider: "IKEA Rental Protection",
      coverageDetails: [
        "Accidental damage",
        "Basic support"
      ],
      cost: 19.99,
      policyNumber: "INS-123457"
    }
  },
  {
    id: "RENTAL-003",
    status: "completed",
    customer: {
      id: "CUST123",
      name: "Sarah Wilson",
      email: "sarah.w@email.com",
      phone: "+1 (555) 789-0123",
      address: "321 Maple Drive, Anytown, ST 12345"
    },
    items: [
      {
        productId: "BILLY001",
        name: "BILLY Bookcase",
        sku: "BILLY-80263832",
        condition: {
          checkout: "Excellent",
          return: "Good"
        },
        pricing: {
          dailyRate: 6.99,
          deposit: 75.00
        }
      }
    ],
    rentalPeriod: {
      startDate: "2024-02-01",
      endDate: "2024-03-01",
      duration: "1 month",
      pickupTime: "11:00 AM",
      returnTime: "4:00 PM"
    },
    location: {
      pickup: "Main Store - Furniture Pickup Area",
      return: "Main Store - Furniture Pickup Area"
    },
    delivery: {
      type: "Self Pickup",
      instructions: "Please bring valid ID"
    },
    pricing: {
      itemsTotal: 209.70,
      delivery: 0,
      deposit: 75.00,
      insurance: 19.99,
      total: 229.69
    },
    insurance: {
      type: "Basic Coverage",
      provider: "IKEA Rental Protection",
      coverageDetails: [
        "Accidental damage",
        "Basic support"
      ],
      cost: 19.99,
      policyNumber: "INS-123458"
    },
    maintenanceHistory: [
      {
        date: "2024-02-15",
        type: "Inspection",
        itemId: "BILLY001",
        technician: "Lisa Chen",
        notes: "Mid-rental inspection, minor wear noted"
      }
    ]
  }
];

// Mock maintenance tasks for rental items
export const mockMaintenanceTasks = [
  {
    id: "MT001",
    rentalId: "RENTAL-001",
    productId: "MALM001",
    itemName: "MALM Bed Frame",
    type: "Scheduled Inspection",
    priority: "medium",
    status: "scheduled",
    assignedTo: "John Smith",
    scheduledDate: "2024-03-25",
    description: "Regular maintenance check and tightening of components",
    location: "Main Store",
    estimatedDuration: "1 hour"
  },
  {
    id: "MT002",
    rentalId: "RENTAL-001",
    productId: "KALLAX001",
    itemName: "KALLAX Shelf Unit",
    type: "Repair",
    priority: "high",
    status: "in_progress",
    assignedTo: "Maria Garcia",
    scheduledDate: "2024-03-22",
    description: "Repair loose shelf and check stability",
    location: "Main Store",
    estimatedDuration: "2 hours"
  }
];

// Mock rental programs
export const mockRentalPrograms = [
  {
    id: "RP001",
    name: "IKEA Basic Rental",
    description: "Monthly rental with basic maintenance",
    status: "active",
    eligibility: "All customers",
    coverage: [
      "Basic furniture maintenance",
      "Monthly quality checks",
      "Standard delivery and pickup"
    ],
    pricing: {
      basic: {
        price: 29.99,
        period: "month",
        features: [
          "Basic maintenance included",
          "Standard delivery",
          "Basic insurance"
        ]
      },
      standard: {
        price: 49.99,
        period: "month",
        features: [
          "Priority maintenance",
          "Express delivery",
          "Extended insurance"
        ]
      }
    },
    metrics: {
      activeRentals: 145,
      successRate: 92,
      avgRentalDuration: 8.5,
      customerSatisfaction: 4.2
    }
  },
  {
    id: "RP002",
    name: "IKEA Student Package",
    description: "Affordable rental package for students",
    status: "active",
    eligibility: "Verified students",
    coverage: [
      "Basic furniture maintenance",
      "Quarterly quality checks",
      "Standard delivery and pickup",
      "Student insurance package"
    ],
    pricing: {
      basic: {
        price: 19.99,
        period: "month",
        features: [
          "Basic maintenance",
          "Standard delivery",
          "Student insurance"
        ]
      }
    },
    metrics: {
      activeRentals: 234,
      successRate: 88,
      avgRentalDuration: 6.2,
      customerSatisfaction: 4.1
    }
  }
]; 